"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_PICKUP_SEARCH_CONFIG = void 0;
/** Pickup search configuration context enhanced by additional properties (mapMethods). */

/**
 * Part of pickup point search configuration data after transformation when it got loaded.
 * Original isInstantResultShown property is renamed to isListInstantResultEnabled here.
 */

/**
 * Pickup point search configuration as it is loaded from server / BackOffice.
 * TO-DO: Still contains the original isInstantResultShown property (should be changed
 * in server code once possible).
 */

const DEFAULT_PICKUP_SEARCH_CONFIG = exports.DEFAULT_PICKUP_SEARCH_CONFIG = {
  display: [],
  filters: [],
  formattedSearchConfiguration: '',
  isListInstantResultEnabled: false,
  mapConfiguration: {},
  mapMethods: {
    current: undefined
  },
  maxDisplayedSearchResults: 10,
  viewSettings: {
    location: {
      latitude: 0,
      longitude: 0
    },
    zoom: 0
  },
  setViewSettings: () => {}
};